import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ product, isActive, onSelect }) => {
  const [imageError, setImageError] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);
  
  // Funcție pentru gestionarea erorilor la încărcarea imaginii
  const handleImageError = () => {
    setImageError(true);
  };

  // Construiește calea către imagine
  const getImagePath = () => {
    // Verifică dacă URL-ul este absolut sau relativ
    if (product.imageUrl && product.imageUrl.startsWith('http')) {
      return product.imageUrl;
    } else if (product.imageUrl) {
      // Concatenează calea relativă cu directorul images/
      return `/images/${product.imageUrl}`;
    }
    return null;
  };

  // Make the entire card clickable
  const handleCardClick = (e) => {
    // Only trigger if the click wasn't on the button or features toggle
    if (!e.target.closest('.features-toggle') && !e.target.closest('.select-btn')) {
      onSelect();
    }
  };

  // Toggle features visibility
  const toggleFeatures = (e) => {
    e.stopPropagation(); // Prevent card click
    setShowFeatures(!showFeatures);
  };

  return (
    <div 
      className={`product-card ${isActive ? 'active' : ''}`}
      onClick={handleCardClick}
    >
      <div className="product-image">
        {product.imageUrl && !imageError ? (
          <img 
            src={getImagePath()} 
            alt={product.name} 
            onError={handleImageError}
            className="product-img"
          />
        ) : (
          <div className="image-placeholder">
            <span>{product.name.charAt(0)}</span>
          </div>
        )}
      </div>
      
      <div className="product-info">
        <h3>{product.name}</h3>
        <p>{product.description}</p>
      </div>
      
      {/* Features teaser and toggle button */}
      <div className="features-header">
        <span className="features-label">Caracteristici</span>
        <button 
          className={`features-toggle ${showFeatures ? 'active' : ''}`} 
          onClick={toggleFeatures}
          aria-label={showFeatures ? 'Ascunde caracteristici' : 'Arată caracteristici'}
        >
          {/* Plus/minus icon */}
          <span className="toggle-icon"></span>
        </button>
      </div>
      
      {/* Features Section - conditionally shown */}
      <div className={`product-features ${showFeatures ? 'expanded' : ''}`}>
        <ul>
          {product.features && product.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductCard;